import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Paper, Typography, Card, CardContent, Button, Stack, Box, Grid, Dialog } from '@mui/material';
import axios from '../../axiosInstance';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer
} from 'recharts';
import SearchBox_ebrary from '../../components/SearchBox_ebrary_journalarticles';
import { styled } from '@mui/system';
import LinkIcon from '@mui/icons-material/Link';

const Journal_Article_Details = ({ onSearch, initialQuery }) => {
  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();


  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New book added to your course", read: false },
    { id: 2, message: "Your library subscription expires soon", read: false }
  ]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const unreadCount = notifications.filter((n) => !n.read).length;

  
  const { id: bookId } = useParams();

  const [item, setItem] = useState(null);
  const [recommendedBooks, setRecommendedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


    
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setUsername(user.username);  // Set username if user is logged in
        setCourseIds(user.courseIds);
        setCollegeId(user.collegeId);
        setDisplayname(user.displayname);
      }
    }, []);



  const { id } = useParams();
  const [showFullAbstract, setShowFullAbstract] = useState(false);



useEffect(() => {
  const fetchItem = async () => {
      if (!id) { // Use `id` from `useParams`
          setError('No article ID provided.');
          return;
      }

      setLoading(true);
      try {
          const response = await axios.get(`https://api.openalex.org/works/${id}`);
          const data = response.data;

          setItem({
            id: data.id.replace('https://openalex.org/', ''),
            title: data.display_name,
            authors: data.authorships.map((auth) => ({
              name: auth.author.display_name,
              url: auth.author.id,
              affiliation: auth.affiliations?.[0]?.raw_affiliation_string || 'Unknown Affiliation',
              institution: auth.institutions?.[0]?.display_name || null,
              institutionId: auth.institutions?.[0]?.id || null,
            })),
            journal: {
              name: data.primary_location?.source?.display_name || 'Unknown Journal',
              url: data.primary_location?.source?.id,
            },
            publisher: {
              name: data.primary_location?.source?.host_organization_name || 'Unknown Publisher',
              url: data.primary_location?.source?.host_organization,
            },
            year: data.publication_year,
            citations: data.cited_by_count,
            references: data.referenced_works_count,
            citationsPerYear: data.counts_by_year || [],
            doi: data.doi,
            oaStatus: data.open_access?.oa_status || 'Closed',
            oaUrl: data.open_access?.oa_url || null,
            abstract: data.abstract_inverted_index
              ? Object.keys(data.abstract_inverted_index).slice(0, 1000).join(' ')
              : 'Abstract not available',
            keywaords: data.keywords,
            topics: [
              {
                label: 'Topic',
                name: data.primary_topic?.display_name,
                url: data.primary_topic?.id,
              },
              {
                label: 'Field',
                name: data.primary_topic?.field?.display_name,
                url: data.primary_topic?.field?.id,
              },
              {
                label: 'Subfield',
                name: data.primary_topic?.subfield?.display_name,
                url: data.primary_topic?.subfield?.id,
              },
  
              {
                label: 'Domain',
                name: data.primary_topic?.domain?.display_name,
                url: data.primary_topic?.domain?.id,
              },
            ],
          });
      } catch (error) {
          console.error('Error fetching item details:', error.message, error.response?.data || 'No additional details');
          setError('Failed to fetch item details.');
      } finally {
          setLoading(false);
      }
  };

  fetchItem();
}, [id]);

if (loading) return <Typography>Loading...</Typography>;
if (error) return <Typography>{error}</Typography>;


const SearchResultsWrapper = styled(Box)(({ theme }) => ({
  width: '60%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 5,
    paddingRight: 5,
  },
}));

const YouTubeResultsWrapper = styled(Box)(({ theme }) => ({
  width: '40%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 0,
  },
}));


  return (
    <main className="flex-grow p-1">


    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">
    <SearchBox_ebrary />

<br />
<Box
  className="main-content"
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' }, // column on mobile, row on desktop
  }}
>
      <SearchResultsWrapper>
        <Box>
      <Typography variant="h4" sx={{ color: 'black', marginBottom: 1 }}>
            {item.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
              {item.authors.map((author, index) => (
                <div key={index} style={{ marginBottom: '6px' }}>
                <Button
                  href={`/journal_articles?filter=authorships.${author.url.replace('https://openalex.org/', '')}`}
                  sx={{ padding: 0, minWidth: 0, textTransform: 'none', marginRight: '5px' }}
                >
                  {author.name}
                </Button>
                {author.affiliation && (
                    <span style={{ color: '#666', fontStyle: 'italic' }}>
                      — {author.affiliation}
                    </span>
                  )}
              </div>
              ))}
        </Typography>

        <Typography variant="body2" color="text.secondary">
            <strong>Published in :</strong> <a href={item.journal.url} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
          {item.journal.name}
        </a>. ({item.year}), <a href={item.publisher.url} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
          {item.publisher.name}. 
        </a>
        </Typography>

        <Typography variant="body2" color="text.secondary">
            <strong>DOI:</strong> {item.doi ? <a href={item.doi} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>{item.doi}</a> : 'N/A'}
        </Typography>
        {item.oaUrl && (
            <Typography variant="body2" color="text.secondary">
                              <strong>Open Access:</strong>{' '}
              {item.oaUrl ? (
                <Button href={item.oaUrl} target="_blank" startIcon={<LinkIcon />}>
                  Open Access Link
                </Button>
              ) : (
                item.oaStatus
              )}({item.oaStatus})
            </Typography>
        )}

            <Typography variant="body2" color="text.secondary" sx={{ marginTop: 2 }}>
              <strong>Abstract:</strong> {item.abstract}
            </Typography>

            <Typography variant="body2" sx={{ marginTop: 2 }}>
              {item.topics.map((topic, index) => (
                <div key={index} style={{ marginBottom: '5px' }}>
                  <strong>{topic.label}:</strong>{' '}
                  <a
                    href={topic.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'blue', textDecoration: 'underline' }}
                  >
                    {topic.name}
                  </a>
                </div>
              ))}
            </Typography>
          </Box>

          <Box sx={{ backgroundColor: '#f5f5f5', paddingY: 2 }}>
            <Grid container justifyContent="center" alignItems="center">

              {/* References */}
              <Grid item xs={12} sm={4} textAlign="center">
                <Typography
                  variant="body1"
                  sx={{ color: '#1976d2', fontWeight: 500, cursor: 'pointer' }}
                >
                  {item.references} References
                </Typography>
              </Grid>

              {/* Citations */}
              <Grid item xs={12} sm={4} textAlign="center">
                <Typography
                  variant="body1"
                  sx={{ color: '#1976d2', fontWeight: 500, cursor: 'pointer' }}
                >
                  {item.citations} Citations
                </Typography>
              </Grid>



              {/* Related Papers */}
              <Grid item xs={12} sm={4} textAlign="center">
                <Typography
                  variant="body1"
                  sx={{ color: '#1976d2', fontWeight: 500, cursor: 'pointer' }}
                >
                  Related Papers
                </Typography>
              </Grid>
            </Grid>
          </Box>

          </SearchResultsWrapper>

          <YouTubeResultsWrapper>
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              <strong>Total Citations:</strong> {item.citations}
            </Typography>

            {/* Citations per Year Chart */}
            {item.citationsPerYear && item.citationsPerYear.length > 0 && (
              <Box sx={{ backgroundColor: '#f9f9f9', borderRadius: 2, padding: 2 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                  Citations Per Year
                </Typography>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart data={[...item.citationsPerYear].reverse()}>
                    <XAxis dataKey="year" fontSize={12} />
                    <YAxis fontSize={12} />
                    <Tooltip />
                    <Bar dataKey="cited_by_count" fill="#8884d8" radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            )}
          </YouTubeResultsWrapper>
      </Box>


    </div>
          </div>
          </main>
  );
};

export default Journal_Article_Details;
